import { FC } from 'react'
import { Chip } from '@mui/material'
import type { CuradoriaReserva } from '@/types/curadoria'

/**
 * Contadores da validação documental na linha da fila (P3, `CuradoriaFilaResponse.Reserva`):
 * itens RECEBIDOS esperando o Operador e itens RECUSADOS. Os números vêm do backend; sem eles
 * (backend anterior à P3) nada aparece.
 */
export const ChipsValidacaoDocumental: FC<{
  r: Pick<CuradoriaReserva, 'itensAguardandoValidacao' | 'itensRecusados'>
}> = ({ r }) => (
  <>
    {(r.itensAguardandoValidacao ?? 0) > 0 && (
      <Chip size="small" color="info" label={`${r.itensAguardandoValidacao} aguardando validação`} />
    )}
    {(r.itensRecusados ?? 0) > 0 && (
      <Chip size="small" color="error" variant="outlined" label={`${r.itensRecusados} recusado(s)`} />
    )}
  </>
)

export default ChipsValidacaoDocumental
